import { requestForQuoteService } from "@sunSource/Services/RequestForQuoteService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export interface RequestForQuoteFormParameter {
    FirstName: string;
    LastName: string;
    Company: string;
    Supplier: string;
    Model: string;
    State: string;
    ZIP: string;
    Phone: string;
    Email: string;
    AdditionalDetailsInquiry: string;
    onSuccess: () => void;
    onError: (error: string) => void;
}

type HandlerType = Handler<RequestForQuoteFormParameter>;

export const SendData: HandlerType = async props => {
    try {
        await requestForQuoteService({ requestForQuoteForm: props.parameter });
        props.parameter.onSuccess();
    } catch (err) {
        // props.parameter.onError(err?.errorMessage || err);
        props.parameter.onError("Something went wrong");
    }
};

export const chain = [SendData];

const submitRequestForQuoteForm = createHandlerChainRunner(chain, "Request For Quote");
export default submitRequestForQuoteForm;
